const SettingsDetails = () => {
    return (
        <div>
            <p>Settings Details</p>
        </div>
    )
}

export default SettingsDetails